import HeroSlider from "./HeroSlider";
// import InfraHero from "./infra/InfraHero";
export default class VerticalInfra {
    constructor() {
        // this.initHero();
        this.initSliders();
    }

    initSliders() {
        const swiperEl = document.querySelector('.infra-hero-slider');
        if(swiperEl) {
            new HeroSlider(swiperEl);
        }
    }

    // initHero() {
    //     const heroEl = document.querySelector('.infra-hero-bg');
    //     if(heroEl) {
    //         new InfraHero(heroEl)
    //     }
    // }
}
